import { z } from "zod";

export const marketingResourceTypeSchema = z.enum([
  "article",
  "tutorial",
  "newsletter",
  "webinar",
  "marketing_poster",
  "web_story",
  "guide",
]);

export const marketingResourceMetadataSchema = z.record(z.string(), z.any());

export const marketingResourceAttachmentSchema = z.object({
  id: z.number(),
  attachment: z.string().url(),
  attachment_type: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const marketingResourceEventTimingSchema = z.object({
  start_time: z.string(),
  end_time: z.string().nullable(),
});

export const marketingResourceSchema = z.object({
  id: z.number(),
  title: z.string(),
  resource_type: marketingResourceTypeSchema,
  preview_image: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  video_link: z.string().nullable().optional(),
  attachment_types: z.array(z.string()).default([]),
  attachments: z.array(marketingResourceAttachmentSchema).default([]),
  created_by: z.string().nullable().optional(),
  publish_date: z.string().nullable().optional(),
  is_featured: z.boolean().default(false),
  metadata: marketingResourceMetadataSchema.default({}),
  event_timings: z.array(marketingResourceEventTimingSchema).default([]),
  updated_at: z.string(),
  duration: z.string().nullable().optional(),
  event_date: z.string().nullable().optional(),
});

export const marketingResourcesListSchema = z.array(marketingResourceSchema);

export const marketingResourceTopicSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional(),
  resource_count: z.union([z.string(), z.number()]).optional(),
  created_at: z.string().nullable().optional(),
  modified_at: z.string().nullable().optional(),
});

export const marketingResourceTopicsListSchema = z.array(
  marketingResourceTopicSchema
);

export const getMarketingResourcesParamsSchema = z.object({
  created_at_gt: z.string().optional(),
  is_featured: z.boolean().optional(),
  month: z.number().int().min(1).max(12).optional(),
  order: z.string().optional(),
  resource_type: marketingResourceTypeSchema.optional(),
  search: z.string().optional(),
  topic_ids: z.array(z.number().int().positive()).optional(),
  page: z.number().int().positive().optional(),
  page_size: z.number().int().positive().optional(),
  year: z.number().int().optional(),
});

export const getMarketingResourceTopicsParamsSchema = z.object({
  resource_type: marketingResourceTypeSchema.optional(),
});
